import React, { Component } from 'react';

import { WithStyles, withStyles } from '@mui/styles';

import APHeading from '../../atoms/APHeading';
import APLabel from '../../atoms/APLabel';
import { withNavigation, withTranslate } from '../../../core/TenantProvider';

import { ReactComponent as TickIcon } from "./assets/tickIcon.svg";
import APLinkSentStyles from './styles/APLinkSent.style';

interface APLinkSentProps extends WithStyles<typeof APLinkSentStyles> {
	translate: Function,
	formEmail: string,
	formMobile: any,
	showEmail: boolean,
	showMobile: boolean
}

class APLinkSent extends Component<APLinkSentProps, {}> {
	render() {
		const {
			classes,
			translate,
			formEmail,
			formMobile,
			showEmail,
			showMobile
		} = this.props;

		let responseText = '';

		if (!showEmail && showMobile) {
			responseText = translate('referral.generator.link.sent.paragraph.text.sms', {
				phone: formMobile
			});
		} else if (showEmail && !showMobile) {
			responseText = translate('referral.generator.link.sent.paragraph.text.email', {
				email: formEmail
			});
		} else {
			responseText = translate('referral.generator.link.sent.paragraph.text.both', {
				email: formEmail,
				phone: formMobile
			});
		}

		return (
			<div className={classes.referralSentContainer}>
				<div className={classes.referralSentCopy}>
					<APHeading className={classes.referralHeading} variant="h4">
						{translate('referral.generator.link.sent.header')}
					</APHeading>
					<APLabel className={classes.referralLabel}>
						{responseText}
					</APLabel>
					<TickIcon />
				</div>
			</div>
		);
	}
}

export default withNavigation(
	withTranslate(
		withStyles(APLinkSentStyles)(APLinkSent)
	)
);
